import React, { useCallback, useEffect, useMemo, useState } from "react";

import { LearnWorkbenchShell } from "../components/layout/LearnWorkbenchShell";

import { ChordHubLibrary } from "../components/chords/hub/ChordHubLibrary";

import { ChordVoicingStudio } from "../components/chords/hub/ChordVoicingStudio";

import { ChordInversionsStudio } from "../components/chords/hub/ChordInversionsStudio";

import { ChordProgressionStudio } from "../components/chords/hub/ChordProgressionStudio";

import { ChordGymDrillStudio } from "../components/chords/hub/ChordGymDrillStudio";

import { resolveChordHubCard } from "../lib/chords/chordHubPlan";

import {

  loadChordHubProgress,

  markChordHubCardComplete,

  saveChordHubProgress,

} from "../lib/chords/chordHubProgress";

import { useProgressionLibrary } from "../hooks/useProgressionLibrary";



export const ChordHubPage: React.FC = () => {

  const { items: userProgressions } = useProgressionLibrary();

  const [activeCardId, setActiveCardId] = useState<string | null>(null);

  const [progress, setProgress] = useState(loadChordHubProgress);

  const [celebrateCardId, setCelebrateCardId] = useState<string | null>(null);



  const activeCard = useMemo(

    () => (activeCardId ? resolveChordHubCard(activeCardId, userProgressions) : null),

    [activeCardId, userProgressions]

  );



  useEffect(() => {

    saveChordHubProgress(progress);

  }, [progress]);



  const handleSelectCard = useCallback((cardId: string) => {

    setActiveCardId(cardId);

  }, []);



  const handleBackToHub = useCallback(() => {

    setActiveCardId(null);

  }, []);



  const handleComplete = useCallback((cardId: string) => {

    setProgress((p) => markChordHubCardComplete(p, cardId));

    setActiveCardId(null);

    setCelebrateCardId(cardId);

    window.setTimeout(() => setCelebrateCardId(null), 2200);

  }, []);



  if (activeCard?.studioKind === "chord-voicing") {

    return (

      <ChordVoicingStudio

        card={activeCard}

        wasCompletedBefore={progress.completedCardIds.includes(activeCard.id)}

        onBack={handleBackToHub}

        onComplete={() => handleComplete(activeCard.id)}

      />

    );

  }



  if (activeCard?.studioKind === "chord-inversions") {

    return (

      <ChordInversionsStudio

        card={activeCard}

        wasCompletedBefore={progress.completedCardIds.includes(activeCard.id)}

        onBack={handleBackToHub}

        onComplete={() => handleComplete(activeCard.id)}

      />

    );

  }



  if (activeCard?.studioKind === "progression-play") {

    return (

      <ChordProgressionStudio

        card={activeCard}

        wasCompletedBefore={progress.completedCardIds.includes(activeCard.id)}

        onBack={handleBackToHub}

        onComplete={() => handleComplete(activeCard.id)}

      />

    );

  }



  if (activeCard?.studioKind === "gym-drill") {

    return (

      <ChordGymDrillStudio

        card={activeCard}

        wasCompletedBefore={progress.completedCardIds.includes(activeCard.id)}

        onBack={handleBackToHub}

        onComplete={() => handleComplete(activeCard.id)}

      />

    );

  }



  return (

    <LearnWorkbenchShell

      activeModule="chords"

      hideLeftSidebar

      sidebar={<div />}

      className="min-h-[100dvh] h-[100dvh]"

    >

      <ChordHubLibrary

        progress={progress}

        celebrateCardId={celebrateCardId}

        userProgressions={userProgressions}

        onSelectCard={handleSelectCard}

      />

    </LearnWorkbenchShell>

  );

};



export default ChordHubPage;

